/**
 * Shown while the game boots. A live status region rather than plain text, so a screen
 * reader announces that something is happening instead of reading an empty page.
 */

export function LoadingScreen() {
  return (
    <div className="overlay">
      <div role="status" aria-live="polite">
        <h1>Lab17 Labyrint</h1>
        <p>Loading…</p>
      </div>
    </div>
  );
}
